import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';
import type { GroupBase, Props } from 'react-select';
import ReactSelect from 'react-select';
import './select.scss';

export * from 'react-select';

export default function Select<
  OptionType,
  IsMulti extends boolean = false,
  GroupType extends GroupBase<OptionType> = GroupBase<OptionType>
>(props: Props<OptionType, IsMulti, GroupType>): ReactElement {
  const { className } = props;
  return (
    <ReactSelect menuPlacement="auto" {...props} className={clsx('react-select', className)} />
  );
}
